import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT, COLORS } from '../config/constants';
import { Sfx } from '../systems/Sfx';
import { Music } from '../systems/Music';
import { updateAdSoundSetting } from '../systems/Ads';
import { openPrivacyCenter } from '../systems/Privacy';

/** Modal settings overlay — launched on top of whichever scene opened it. */
export class SettingsScene extends Phaser.Scene {
  private musicLabel!: Phaser.GameObjects.Text;
  private sfxLabel!: Phaser.GameObjects.Text;
  private returnTo!: string;

  constructor() {
    super('Settings');
  }

  init(data: { returnTo: string }): void {
    this.returnTo = data.returnTo;
  }

  create(): void {
    this.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, GAME_WIDTH, GAME_HEIGHT, 0x000000, 0.55);
    this.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 2, 'ui_panel').setScale(1, 1.12);

    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 125, 'Settings', {
        fontFamily: 'Georgia, serif',
        fontSize: '36px',
        color: '#ffffff'
      })
      .setOrigin(0.5);

    this.add
      .text(GAME_WIDTH / 2 - 100, GAME_HEIGHT / 2 - 60, 'Music', {
        fontFamily: 'Arial',
        fontSize: '24px',
        color: '#ffffff'
      })
      .setOrigin(0, 0.5);
    this.musicLabel = this.createToggle(GAME_WIDTH / 2 + 100, GAME_HEIGHT / 2 - 60, Music.isEnabled(), () => {
      Music.setEnabled(!Music.isEnabled());
      this.musicLabel.setText(Music.isEnabled() ? 'On' : 'Off');
      updateAdSoundSetting();
      Sfx.buttonTap();
    });

    this.add
      .text(GAME_WIDTH / 2 - 100, GAME_HEIGHT / 2, 'SFX', {
        fontFamily: 'Arial',
        fontSize: '24px',
        color: '#ffffff'
      })
      .setOrigin(0, 0.5);
    this.sfxLabel = this.createToggle(GAME_WIDTH / 2 + 100, GAME_HEIGHT / 2, Sfx.isEnabled(), () => {
      Sfx.setEnabled(!Sfx.isEnabled());
      this.sfxLabel.setText(Sfx.isEnabled() ? 'On' : 'Off');
      updateAdSoundSetting();
      Sfx.buttonTap();
    });

    const removeAdsButton = this.add
      .rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 60, 230, 48, COLORS.fusionGold, 1)
      .setStrokeStyle(3, COLORS.outline)
      .setInteractive({ useHandCursor: true });
    const removeAdsLabel = this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 60, 'Remove Ads', {
        fontFamily: 'Arial',
        fontSize: '20px',
        color: '#2e2a38',
        fontStyle: 'bold'
      })
      .setOrigin(0.5);
    removeAdsButton.on('pointerdown', () => {
      Sfx.buttonTap();
      removeAdsLabel.setText('Coming soon');
    });

    const privacyText = this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 100, 'Privacy choices', {
        fontFamily: 'Arial',
        fontSize: '18px',
        color: '#ffffff'
      })
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true });
    privacyText.on('pointerdown', () => {
      Sfx.buttonTap();
      openPrivacyCenter();
    });

    const closeText = this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 135, 'Close', {
        fontFamily: 'Arial',
        fontSize: '22px',
        color: '#ffffff'
      })
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true });
    closeText.on('pointerdown', () => {
      Sfx.buttonTap();
      this.close();
    });

    this.input.keyboard?.on('keydown-ESC', () => this.close());
  }

  private close(): void {
    this.scene.stop();
    this.scene.resume(this.returnTo);
  }

  /** A small pill button that flips a boolean and calls onToggle; returns its label text object. */
  private createToggle(x: number, y: number, initial: boolean, onToggle: () => void): Phaser.GameObjects.Text {
    const button = this.add
      .rectangle(x, y, 90, 44, COLORS.fusionGold, 1)
      .setStrokeStyle(3, COLORS.outline)
      .setInteractive({ useHandCursor: true });
    const label = this.add
      .text(x, y, initial ? 'On' : 'Off', { fontFamily: 'Arial', fontSize: '20px', color: '#2e2a38', fontStyle: 'bold' })
      .setOrigin(0.5);
    button.on('pointerover', () => button.setScale(1.05));
    button.on('pointerout', () => button.setScale(1));
    button.on('pointerdown', onToggle);
    return label;
  }
}
